import React, { useState } from 'react';
import { renderParagraphs } from '../utils/textFormatters';
import { useTheme } from '../context/ThemeContext';

const ToggleableDetails = ({ title, paragraphs, customContent }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { darkMode } = useTheme();

  return (
    <div className="my-6">
      {/* Button for toggling - hidden when printing */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="group flex items-center w-auto focus:outline-none print:hidden"
      >
        <div className={`flex items-center justify-center w-6 h-6 mr-3 rounded-full border-2 border-[#2978C8] dark:border-[#4f9cf9] transition-colors duration-300 ${isOpen ? 'bg-[#2978C8] dark:bg-[#4f9cf9]' : 'bg-transparent'}`}>
          <svg 
            className={`w-3 h-3 transition-transform duration-300 ${isOpen ? 'rotate-180' : 'rotate-0'}`} 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke={isOpen ? 'white' : (darkMode ? '#4f9cf9' : '#2978C8')}
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
        <span className="text-lg font-medium text-[#294C6F] dark:text-[#4f9cf9] group-hover:text-[#2978C8] dark:group-hover:text-[#7fb5fa] transition-colors duration-300">
          {title}
        </span>
      </button>
      
      {/* Title for print only - shows when printing */}
      <div className="hidden print:block print:mb-4">
        <h4 className="text-lg font-medium text-[#294C6F] dark:text-[#4f9cf9]">
          {title}
        </h4>
      </div>
      
      {/* Content container - different styles for screen vs print */}
      <div 
        className={`overflow-hidden transition-all duration-500 ease-in-out print:max-h-full print:opacity-100 print:overflow-visible ${
          isOpen ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="mt-4 ml-9 pl-6 border-l-2 border-[#2978C8] dark:border-[#4f9cf9] text-lg text-[#333333] dark:text-white leading-relaxed print:mt-0 print:ml-0 print:pl-0 print:border-l-0 print:mb-6">
          {customContent ? customContent : renderParagraphs(paragraphs)}
        </div>
      </div>
    </div>
  );
};

export default ToggleableDetails; 